<template>
  <div class="app-loader u-bg-grey-light">
    <div class="app-loader__bar u-bg-white u-w8of8 t-translate__right-enter-active" :style="{transform: `scaleX(${load}) translateZ(0)`}" />
  </div>
</template>

<script>
export default {
  props: {
    load: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.app-loader
  &__bar
    height 2px
    transform-origin 0% 50%
    transition transform .5s ease-in-out-quad
</style>